import React from 'react';
import { Box, Typography } from '@material-ui/core';

import CustomSwitch from '../../../common/custom-switch/CustomSwitch';
import { componentSettingStyle } from '../styles';
import { useComandaSetting } from './useComandaSetting';

export function ComandaSetting() {
  const styles = componentSettingStyle();
  const {
    title,
    description,
    isActivated,
    toggleActivated,
  } = useComandaSetting();

  return (
    <Box className={styles.container}>
      <Box>
        <Typography className={styles.title}>{title}</Typography>
        <Typography className={styles.description}>{description}</Typography>
      </Box>
      <Box className={styles.alignSwitchMobile}>
        <CustomSwitch
          checked={isActivated}
          onChange={() => toggleActivated(isActivated)}
        />
      </Box>
    </Box>
  );
}
